<div class="register-panel">
  <div style="display: flex; flex-direction: column; align-items: center; margin-top: 60px">
    <h4>Sign up</h4>
    <form #registerForm="ngForm"
          (ngSubmit)="onSubmit()">
      <div class="form-control">
        <input type="text"
               name="email"
               [(ngModel)]="email"
               #emailModel="ngModel"
               required
               placeholder="Email">
        <div class="input-error" *ngIf="emailModel.errors && (emailModel.dirty || emailModel.touched)">
          <p *ngIf="emailModel.errors.required">Username is required</p>
          <p *ngIf="emailModel.errors.pattern">Invalid username</p>
          <p *ngIf="emailModel.errors.minlength">The minimum length for username is 2</p>
          <p *ngIf="emailModel.errors.maxlength">The maximum length for username is 18</p>
        </div>
      </div>
      <div class="form-control">
        <input type="text"
               name="phoneNumber"
               [(ngModel)]="phoneNumber"
               #phoneNumberModel="ngModel"
               required
               placeholder="Phone">
        <div class="input-error" *ngIf="phoneNumberModel.errors && (phoneNumberModel.dirty || phoneNumberModel.touched)">
          <p *ngIf="phoneNumberModel.errors.required">Username is required</p>
          <p *ngIf="phoneNumberModel.errors.pattern">Invalid username</p>
          <p *ngIf="phoneNumberModel.errors.minlength">The minimum length for username is 2</p>
          <p *ngIf="phoneNumberModel.errors.maxlength">The maximum length for username is 18</p>
        </div>
      </div>
      <div class="form-control">
        <input type="password"
               name="password"
               [(ngModel)]="password"
               #passwordModel="ngModel"
               required
               placeholder="Password">
        <div class="input-error" *ngIf="passwordModel.errors && (passwordModel.dirty || passwordModel.touched)">
          <p *ngIf="passwordModel.errors.required">Password is required</p>
          <p *ngIf="passwordModel.errors.pattern">Invalid password</p>
          <p *ngIf="passwordModel.errors.minlength">The minimum length for username is 6</p>
          <p *ngIf="passwordModel.errors.maxlength">The maximum length for username is 12</p>
        </div>
      </div>
      <div class="form-control">
        <button [ngClass]="{'deactivated': isLoading}"
                [disabled]="isLoading">
          <ng-container *ngIf="!isLoading">
            Sign up
          </ng-container>
          <div style="height: 36px; display: flex; align-items: center">
            <mat-spinner *ngIf="isLoading"
                         diameter="20"
                         class="custom-spinner"
                         style="height: 20px; width: 20px"></mat-spinner>
          </div>

        </button>
      </div>
    </form>
    <div routerLink="/auth/login" class="have-account">
      Already have an account?
    </div>
  </div>
  <div style="font-size: 12px; color: #3C50E0; margin-bottom: 20px">Powered by Yep Home ©</div>

</div>
